module.exports = __webpack_public_path__ + "img/cons_3.5f945b76.jpg";